import { createContext, ReactNode, useContext } from 'react';
import { HeaderProps, MenuItemType, WithChildren } from '../../components/app/compound/Header/Header.types';

export type HeaderContextType = {
  showMobileMenu: boolean;
  setShowMobileMenu: (show: boolean) => void;
  profileItems: MenuItemType[];
  primaryItems: WithChildren<MenuItemType>[];
} & Pick<HeaderProps, 'regions' | 'localeSwitcherLabel' | 'localeSwitcherIcon'>;

const HeaderContext = createContext<HeaderContextType>({} as HeaderContextType);

export default ({ children, value }: { children: ReactNode; value: HeaderContextType }) => {
  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};

export const useHeaderContext = () => useContext(HeaderContext);
